import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import Palette from '../Palette';
import { FaDownload } from "react-icons/fa";

export default function RegisterIntroduction({ onRegister }) {
    return (
        <>
            <Container className="py-5">
                <Row className="text-center mb-5">
                    <Col>
                        <h1 className="mb-4">Bergabung Bersama HPI</h1>
                        <p className="mx-auto">
                            Untuk menjadi anggota Himpunan Penerjemah Indonesia (HPI), Anda dapat mendaftar sebagai Penerjemah atau Juru Bahasa. Pelajari apa saja yang perlu Anda siapkan dan persyaratan yang harus dipenuhi sebelum melakukan pendaftaran.
                        </p>
                        <Button onClick={() => {
                            onRegister()
                        }} style={{
                            fontFamily: 'Signika',
                            fontWeight: '600',
                            paddingTop: 10,
                            paddingBottom: 10,
                            minWidth: '30%',
                            backgroundColor: Palette.PRIMARY,
                            borderColor: Palette.PRIMARY,
                        }} variant="primary" className="mt-3 px-5 py-2" href="#" size="lg">
                            Ajukan
                        </Button>
                    </Col>
                </Row>

                <hr className="my-5" />

                <Row className="justify-content-center mt-5 g-4">
                    <Col md={6} className='mb-3'>
                        <Card className="h-100" style={{ borderRadius: '15px', border: `1px solid ${Palette.PRIMARY}` }}>
                            <Card.Body className="p-4">
                                <div style={{ gap: 10 }} className="d-flex align-items-center mb-4">
                                    <div style={{ background: Palette.PRIMARY }} className="rounded-circle p-2 me-3">
                                        <img src='/ic_sign_document.svg' />
                                    </div>
                                    <h4 style={{ color: Palette.PRIMARY }} className="mb-0">Penerjemah</h4>
                                </div>

                                <p className="mb-4">Untuk Mendaftar Sebagai Anggota HPI Kategori Penerjemah, Anda Perlu Menyiapkan Dokumen Dan Informasi Berikut:</p>

                                <ol>
                                    <li className="mb-3">
                                        <strong>Identitas Diri</strong>
                                        <ul className="mt-2">
                                            <li>KTP Atau Paspor Yang Masih Berlaku</li>
                                            <li>Foto Terbaru Berukuran Pas Foto</li>
                                        </ul>
                                    </li>

                                    <li className="mb-3">
                                        <strong>Bukti Kualifikasi Profesional</strong>
                                        <ul className="mt-2">
                                            <li>Ijazah Pendidikan Terakhir</li>
                                            <li>Sertifikat Pelatihan/Pendidikan Terkait Penerjemahan (Jika Ada)</li>
                                        </ul>
                                    </li>

                                    <li className="mb-3">
                                        <strong>Portfolio Penerjemahan</strong>
                                        <ul className="mt-2">
                                            <li>Contoh Hasil Terjemahan Minimal 2 Dokumen Dari Bahasa Asing Ke Bahasa Indonesia Dan Sebaliknya</li>
                                            <li>Deskripsi Singkat Konteks Dan Tujuan Dari Dokumen Yang Diterjemahkan</li>
                                        </ul>
                                    </li>

                                    <li className="mb-3">
                                        <strong>Pernyataan Etika Profesi</strong>
                                        <ul className="mt-2">
                                            <li>Menyetujui Dan Menandatangani Kode Etik Penerjemah HPI</li>
                                        </ul>
                                    </li>
                                </ol>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={6} className='mb-3'>
                        <Card className="h-100" style={{ borderRadius: '15px', border: `1px solid ${Palette.PRIMARY}` }}>
                            <Card.Body className="p-4">
                                <div style={{ gap: 10 }} className="d-flex align-items-center mb-4">
                                    <div style={{ background: Palette.PRIMARY }} className="rounded-circle p-2 me-3">
                                        <img src='/ic_voice.svg' />
                                    </div>
                                    <h4 style={{ color: Palette.PRIMARY }} className="mb-0">Juru Bahasa</h4>
                                </div>

                                <p className="mb-4">Untuk Mendaftar Sebagai Anggota HPI Kategori Juru Bahasa (Interpreter), Berikut Persyaratannya:</p>

                                <ol>
                                    <li className="mb-3">
                                        <strong>Identitas Diri</strong>
                                        <ul className="mt-2">
                                            <li>KTP Atau Paspor Yang Masih Berlaku</li>
                                            <li>Foto Terbaru Berukuran Pas Foto</li>
                                        </ul>
                                    </li>

                                    <li className="mb-3">
                                        <strong>Bukti Kualifikasi Profesional</strong>
                                        <ul className="mt-2">
                                            <li>Ijazah Pendidikan Terakhir</li>
                                            <li>Sertifikat Pelatihan Atau Workshop Interpretasi (Jika Ada)</li>
                                        </ul>
                                    </li>

                                    <li className="mb-3">
                                        <strong>Portfolio Interpretasi</strong>
                                        <ul className="mt-2">
                                            <li>Rekam Jejak Pengalaman Sebagai Juru Bahasa (Minimal 2 Kegiatan)</li>
                                            <li>Surat Keterangan Dari Penyelenggara Acara (Jika Tersedia)</li>
                                        </ul>
                                    </li>

                                    <li className="mb-3">
                                        <strong>Pernyataan Etika Profesi</strong>
                                        <ul className="mt-2">
                                            <li>Menyetujui Dan Menandatangani Kode Etik Juru Bahasa HPI</li>
                                        </ul>
                                    </li>
                                </ol>

                                <Button onClick={() => {
                                    const filePath = '/SUKET_Pelaksanaan_Kerja_Penjurubahasaan.docx';
                                    const link = document.createElement('a');
                                    link.href = filePath;
                                    link.download = 'SUKET_Pelaksanaan_Kerja_Penjurubahasaan.docx';
                                    document.body.appendChild(link);
                                    link.click();
                                    document.body.removeChild(link);
                                }} style={{ borderColor: Palette.PRIMARY, background: Palette.PRIMARY, color: '#fff' }} variant='primary'>
                                    <div style={{ gap: 4 }} className='d-flex align-items-center g-2'>
                                        <FaDownload />
                                       Unduh template surat keterangan

                                    </div>
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    )
}